const SHOP_ID = "6885359";

// Hosted new Customer Accounts entry point (Settings → Customer accounts in Shopify Admin).
// On headless stores, Sign in with Shop uses paths on the primary domain; netlify.toml
// proxies those to Shopify so this URL works on first click.
const DEFAULT_CUSTOMER_ACCOUNTS_URL = `https://shopify.com/${SHOP_ID}/account`;

export const getCustomerAccountsUrl = () => {
  const configuredUrl = process.env.GATSBY_SHOPIFY_CUSTOMER_ACCOUNTS_URL;

  if (configuredUrl && configuredUrl.startsWith("http")) {
    return configuredUrl;
  }

  return DEFAULT_CUSTOMER_ACCOUNTS_URL;
};
